import {useEffect,useState} from "react";
import {API} from "../lib/api";
import {PageHeader,Spinner} from "../components/common";
import {FollowUpEngine} from "../components/FollowUpEngine";

export default function FollowUps(){
  const [agents,setAgents]=useState(null),[agent,setAgent]=useState("agent-consultative");
  useEffect(()=>{API.get("/sales-agents").then(r=>setAgents(r.data));},[]);
  if(!agents)return <Spinner/>;
  return <div>
    <PageHeader title="Follow-ups" subtitle="Short-term no-response recovery. This queue is separate from campaigns and long-term nurturing."/>
    <div className="mb-card p-4 mb-4 flex flex-wrap items-end gap-4">
      <div className="flex-1 min-w-64"><div className="text-sm font-semibold">Follow-up owner</div><div className="text-xs text-slate-500 mt-1">Only inactive, consented qualification leads enter this workflow. A new reply cancels every pending touch.</div></div>
      <label className="text-xs text-slate-400">AI agent<select value={agent} onChange={e=>setAgent(e.target.value)} className="block mt-1 bg-slate-900 border border-slate-700 rounded-lg px-3 py-2 text-slate-200">{agents.map(a=><option key={a.id} value={a.id}>{a.name}</option>)}</select></label>
    </div>
    <FollowUpEngine agentId={agent} agentName={agents.find(a=>a.id===agent)?.name||"AI Agent"}/>
  </div>;
}
